import styled from 'styled-components';

import { responsive, sp } from '@main/theme';

/**
 * Widget wrapper
 */
export const WidgetWrapper = styled.div`
  margin-top: ${sp(6)};
`;

/** Mobile sidebar wrapper */
export const MobileSidebarWrapper = styled.div`
  ${responsive.atLeastTablet} {
    display: none;
  }
`;

/**
 * Desktop sidebar wrapper
 */
export const DesktopSidebarWrapper = styled.div`
  display: none;

  ${responsive.atLeastTablet} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.colors.sidebarNavBg};
    height: 100%;
  }
`;

/**
 * The Sidebar wrapper
 */
export const SidebarWrapper = styled.nav`
  height: 100%;
`;
